import React from 'react';
import {Link} from 'react-router-dom';
import logo_2 from '../../../styles/img/organizations/logo_2.png';
import logo_2x from '../../../styles/img/organizations/logo_2@2x.png';
import logo_3x from '../../../styles/img/organizations/logo_2@3x.png';
import './styles.css';

const CreateWorkshopInfo = () => {
  return (
    <div className="cwi-container">
      <section className="cwi-top-section swi-section">
        <div className="hero__content home_hero_content" style={{maxWidth: 'initial'}}>
          <div className="hero__block">
            <div className="hero__logo">
              <img src={logo_2} srcSet={`${logo_2x} 2x, ${logo_3x} 3x`} alt="TherapyAcademy" />
            </div>
            <div>
              {/* <h2 className="invest-title">CREATE YOUR WORKSHOP ONLINE</h2> */}
              <p className="invest-slogan">Create your workshop online - it's free!</p>
              <ul className="invest-professions">
                <li>If you already deliver face-to-face workshops or would like to set up a new workshop, you can take your specific approach and turn it into an online workshop.</li>
              </ul>
              <Link className="btn prime bordered" to='/createwebinar'>CREATE WORKSHOP - IT’S FREE</Link>
            </div>
          </div>
        </div>
      </section>

      <section className="cwi-how-it-works-section swi-section">
        <p className="invest-slogan">HOW IT WORKS</p>
        <div className="cwi-create-container">
          <ul className="cwi-create-list">
            <p className="cwi-create-list-header">Create Your Workshop Online</p>
            <li className="cwi-create-list-item">It's free to publish your workshop to Therapy Academy</li>
            <li className="cwi-create-list-item">You set your workshop fee</li>
            <li className="cwi-create-list-item">You keep 80% of the fee, Therapy Academy charges 20%</li>
            <li className="cwi-create-list-item">We are here to help you every step of the way</li>
          </ul>
        </div>
        <div className="cwi-promote-container">
          <ul className="cwi-create-list cwi-promote-list">
            <p className="cwi-create-list-header">Promote Your Workshop</p>
            <li className="cwi-create-list-item">We will promote your workshop on a number of marketing channels, including our own database of 5,000 members</li>
            <li className="cwi-create-list-item">We will show you how to promote your workshop outside of Therapy Academy too</li>
          </ul>
        </div>
        <div className="cwi-how-it-works-bottom">
          <p className="cwi-start-earning">Start Earning</p>
          <p className="cwi-paragraph">Receive a monthly payment reflecting the total number of purchases of your workshop for that month, net of Therapy Academy’s fee.</p>
        </div>
      </section>

      <section className="cwi-why-container swi-section">
        <p className="invest-slogan">Why Therapy Academy?</p>
        <div className="cwi-why-lists-container">
          <ul className="cwi-why-list">
            <li className="cwi-why-list-item">We manage all technical aspects, enabling you to focus on your workshop</li>
            <li className="cwi-why-list-item">We handle all online payments - reducing admin for you</li>
          </ul>
          <ul className="cwi-why-list">
            <li className="cwi-why-list-item">We offer multiple options of workshop delivery: live webinar, pre-recorded and more…</li>
            <li className="cwi-why-list-item">There are no setup, hosting or any other charges</li>
          </ul>
        </div>
        <div className="cwi-button-wrapper">
          <Link className="btn prime bordered" to='/createwebinar'>CREATE WORKSHOP - IT’S FREE</Link>
          {/* <p className="cwi-blue-text">CREATE YOUR WORKSHOP ONLINE - IT’S FREE</p> */}
        </div>
      </section>

      <section className="cwi-workshop-types swi-section">
        <p className="invest-slogan">WORKSHOP TYPES</p>
        <p>We can help you decide which approach works best for you.</p>
        <div className="cwi-types-lists">
          <ul className="cwi-create-list cwi-promote-list cwi-types-list">
            <p className="cwi-create-list-header">Live Webinars</p>
            <li className="cwi-create-list-item">Enables you to present to a large audience with chat Q&A style interaction or your participants can interact live through video and audio</li>
            <li className="cwi-create-list-item">CPD certs automatically generated on successful completion of webinar and an accompanying online quiz</li>
          </ul>
          <ul className="cwi-create-list cwi-promote-list cwi-types-list">
            <p className="cwi-create-list-header">Online Workshops / Courses</p>
            <li className="cwi-create-list-item">Available 24/7. Participants learn at their own pace, in their own time</li>
            <li className="cwi-create-list-item">Mixture of written content, images, recorded video presentations, video content, articles or research documents. Workshops consist of modules, with an online quiz at the end of each module</li>
            <li className="cwi-create-list-item">CPD certs automatically generated on successful completion of course and accompanying quizzes</li>
          </ul>
          <ul className="cwi-create-list cwi-promote-list cwi-types-list">
            <p className="cwi-create-list-header">In-Person Workshops</p>
            <li className="cwi-create-list-item">We can promote your in person workshops taking care of all promotional, payment, hosting, attendee management and CPD practicalities</li>
          </ul>
        </div>
      </section>

      <section className="cwi-accreditation-section swi-section">
        <p className="invest-slogan">CPD ACCREDITATION</p>
        <ul className="cwi-why-list cwi-accreditation-list">
          <li className="cwi-why-list-item">CPD certs are automatically created for you for each of your workshops</li>
          <li className="cwi-why-list-item">Workshop participants download a CPD cert upon completion of an online quiz that we help you set up</li>
        </ul>
      </section>

      <section className="swi-next-steps-container swi-section">
        <div className="swi-next-steps-wrapper">
          <p className="invest-slogan">Next Steps</p>
          <p>Contact us at <a href="mailto:support@therapyacademy.ie">support@therapyacademy.ie</a> or on <a href="tel:087 3356536">087 3356536</a> and we can work with you to get your workshop set up immediately.</p>
        </div>
        <div className="swi-next-steps-wrapper">
          <h2 className='create-course-header' style={{textAlign: 'center'}}>TESTIMONIALS</h2>
          <p className="brackets">❛❛</p>
          <p className="swi-thanks">
            <br />
            Thanks so much Therapy Academy for marketing and managing all the bookings for my online training provision. Your professionalism, excellent course layout and clear communication to me and participants throughout really optimised the outcome. 
          </p>
          <p style={{color: '#8e8e8e'}}><br />- Ann Bracken, Counselling Psychotherapist</p>
        </div>
      </section>
    </div>
  );
};

export default CreateWorkshopInfo;



// WEBPACK FOOTER //
// ./src/components/informations/createWorkshopInfo/index.jsx